/**
 * Created by avasilescu on 7-Aug-2018.
 */
import React, {Component} from 'react';

const STAGED_PM_CATEGORY_SUFFIX = '_IVR';

class StagingReviewPayment extends Component {

    static isStagedPMCategory(pmCategory) {
        return pmCategory && pmCategory.endsWith(STAGED_PM_CATEGORY_SUFFIX);
    }
    
    transferInstructionLabel(){
        return messages["transfer.instructions.label"];
    }
    
    render() {
        const {config, data} = this.props;
        const {messages} = config;
        const pm = data.paymentMethod;
        const pmCategory = pm.paymentMethodCategory;
        const show = StagingReviewPayment.isStagedPMCategory(pmCategory);

        return show && (
            <div className="ivr-transfer-container" style={{display: 'block'}}>
                <div className="ivr-transfer-components">
                    <h4 className="subsection-title">{messages["transfer.dialog.title"]}</h4>
                    <div className="ivr-transfer-note">
                        <p>{this.transferInstructionLabel()}</p>
                    </div>
                </div>
            </div>
        ) || null;
    }

}


export default StagingReviewPayment;
